var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.814453,
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#636363"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.128 12.7485H12.2781C11.3866 12.7485 10.6799 13.4633 10.6799 14.3548L10.6719 23.9922C10.6719 24.8836 11.3866 25.5984 12.2781 25.5984H25.128C26.0194 25.5984 26.7342 24.8836 26.7342 23.9922V14.3548C26.7342 13.4633 26.0194 12.7485 25.128 12.7485ZM25.128 23.9922H12.2781V19.1735H25.128V23.9922ZM25.128 15.961H12.2781V14.3548H25.128V15.961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.891cd89e95f492cf5e6308c6bb8b885c.svg";
export { ForwardRef as ReactComponent };